import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SettingsComponent} from './settings.component';
import {RouterModule} from '@angular/router';
import {DialogProgressModule} from '../shared/components/dialog-progress/dialog-progress.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputModule} from '../shared/components/input/input.module';
import {AlertModule} from '../shared/components/alert/alert.module';
import {DropdownModule} from '../shared/components/dropdown/dropdown.module';
import {DialogModule} from '../shared/components/dialog/dialog.module';
import {PinInputModule} from '../shared/components/pin-input/pin-input.module';
import {PharmacyDetailsModule} from '../shared/components/pharmacy-details/pharmacy-details.module';
import {ButtonModule} from '../shared/components/button/button.module';
import {WarningDialogModule} from '../shared/components/warning-dialog/warning-dialog.module';
import {WholesalerIntegrationTableComponent} from './components/wholesaler-integration-table/wholesaler-integration-table.component';
import {TabsModule} from '../shared/components/tabs/tabs.module';
import {BadgeModule} from '../shared/components/badge/badge.module';
import {FormattedDateModule} from '../shared/pipes/formatted-date/formatted-date.module';
import {MenuModule} from '../shared/components/menu/menu.module';
import {WholesalerResultMessageModule} from '../shared/components/wholesaler-result-message/wholesaler-result-message.module';
import { PharmacyManagementSystemIntegrationTableComponent } from './components/pms-integration-table/pms-integration-table.component';
import { AdminGuard } from '../shared/guards/admin.guard';
import { InputSearchScannerModule } from '../shared/components/input-search-scanner/input-search-scanner.module';
import { OptionsListModule } from '../shared/components/options-list/options-list.module';
import { WholesalerIntegrationDialogModule } from './components/dialogs/wholesaler-integration-dialog/wholesaler-integration-dialog.module';
import { PmsIntegrationDialogModule } from './components/dialogs/pms-integration-dialog/pms-integration-dialog,module';
import { EditProfileDialogComponent } from './components/dialogs/edit-profile-dialog/edit-profile-dialog.component';
import { EnableC3C5WorkflowModule } from './components/dialogs/enable-c3-c5-workflow/enable-c3-c5-workflow.module';
import { EnableC3C5SettingComponent } from './components/enable-c3-c5-setting/enable-c3-c5-setting.component';
import { InventoryLocationsSettingModule } from './components/inventory-locations/inventory-locations-setting.module';
import { AddEditInventoryLocationDialogComponent } from './components/dialogs/add-edit-inventory-location-dialog/add-edit-inventory-location-dialog.component';
import { TextareaModule } from '../shared/components/textarea/textarea.module';
import { BackCountComponent } from './components/back-count/back-count.component';
import { ChecklistModule } from '../shared/checklist/checklist.module';
import { CompoundingComponent } from './components/compounding/compounding.component';
import { CheckboxGroupModule } from '../shared/checkbox-group/checkbox-group.module';
import { OverflowClassModule } from '../shared/directives/detect-content-overflow/overflow-class.module';


const routes = [
  {
    path: '', component: SettingsComponent,
    children: [],
    canActive: AdminGuard
  },
];

@NgModule({
  declarations: [
    SettingsComponent,
    WholesalerIntegrationTableComponent,
    PharmacyManagementSystemIntegrationTableComponent,
    EnableC3C5SettingComponent,
    BackCountComponent,
    CompoundingComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    DialogProgressModule,
    FormsModule,
    ReactiveFormsModule,
    InputModule,
    AlertModule,
    DropdownModule,
    DialogModule,
    PinInputModule,
    PharmacyDetailsModule,
    ButtonModule,
    WarningDialogModule,
    TabsModule,
    BadgeModule,
    FormattedDateModule,
    MenuModule,
    WholesalerResultMessageModule,
    InputSearchScannerModule,
    OptionsListModule,
    PmsIntegrationDialogModule,
    WholesalerIntegrationDialogModule,
    EnableC3C5WorkflowModule,
    InventoryLocationsSettingModule,
    ChecklistModule,
    CheckboxGroupModule,
    OverflowClassModule
  ],
  exports: [EditProfileDialogComponent],
})
export class SettingsModule {
}
